import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets,
    {
      name: 'SearchBox_home',
      type: 'SearchBoxDialogButton',
      location: { selector: '#cm-search-box-home', class: 'cm-search-box cm_search-box-root__home' },
      disableDropdown: true,
      template: 'searchBox/dialogButtonAdaptable',
    },
  ],
};
